import {
  SET_DISRUPTION,
  SET_LOADING_DISRUPTION,
  SET_NEW_DISRUPTION,
  SET_DELETE_DISRUPTION,
  SET_DELETE_ALL_DISRUPTION,
  SET_ERROR_PROMPT_DISRUPTION,
  SET_ERROR_MESSAGE_DISRUPTION,
  SET_SUCCESS_PROMPT_DISRUPTION,
  SET_SUCCESS_MESSAGE_DISRUPTION,
  SET_DISRUPTION_ANNOUNCEMENT,
  SET_LINES,
} from "../../actionTypes/smrt/disruptionActionType";
import { handleError } from "../../../../store/handleError";

import { initiateAXIOS } from "../../../../config/axios";
import {
  instanceDisruptionEventAPI as disruptionAPI,
  instanceDisruptionAnnouncementAPI as announcementAPI,
  instanceDisruptionLineAPI,
  instanceDisruptionStationAPI,
  initiateScheduleAPI,
} from "../../../../api";
import Disruption from "../../../../models/DisruptionModel";
import Announcement from "../../../../models/AnnouncementModel";
import { logger } from "../../../../helpers/logger";
import Line from "../../../../models/LineModel";
import Schedule from "../../../../models/ScheduleModel";

const handleTimeoutSuccessPrompt = (dispatch) => {
  setTimeout(() => {
    dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: false });
  }, 3000);
};

const handleTimeoutErrorPrompt = (dispatch) => {
  setTimeout(() => {
    dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: false });
  }, 5000);
};

// TODO check if will be used or not
// const generateDirectionData = (data) => {
//   let dirData = {};
//   let direction = {};

//   if (data.direction === "BOTH") {
//     direction["station"] = data.direction;
//   } else {
//     direction["station"] = data?.lastStation?.abbr;
//   }

//   direction["name"] = data.direction;
//   dirData["direction"] = direction;

//   dirData["from"] = data.fromStation;
//   dirData["to"] = data.toStation;

//   if (data.fromStation.order > data.toStation.order) {
//     dirData["from"] = data.toStation;
//     dirData["to"] = data.fromStation;
//   }

//   return dirData;
// };

export const getLines = () => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    try {
      const { data } = await initiateAXIOS.get(
        instanceDisruptionLineAPI + "?limit=100",
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      const listLine = data.items;
      const listWithStations = await Promise.all(
        listLine.map(async (line) => {
          const station = await initiateAXIOS.get(
            instanceDisruptionStationAPI +
              "?limit=100&sortBy=abbreviationAsc&isDisabled=false&lineId=" +
              line.id,
            {
              headers: { authorization: `Bearer ${access_token}` },
            }
          );

          return {
            ...line,
            stations: station.data.items,
          };
        })
      );

      let lines = [];
      listWithStations.map((item) => lines.push(new Line(item)));
      dispatch({ type: SET_LINES, payload: lines });
    } catch (error) {
      logger.error(error);
    }
  };
};

export const getDisruption = () => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });

    try {
      const { data } = await initiateAXIOS.get(disruptionAPI, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      let disruptions = [];
      data.items.map((data) => disruptions.push(new Disruption(data)));

      dispatch({ type: SET_DISRUPTION, payload: disruptions });
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const createDisruption = (payload) => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    try {
      const { data } = await initiateAXIOS.post(disruptionAPI, payload, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      dispatch({
        type: SET_NEW_DISRUPTION,
        payload: new Disruption(data),
      });

      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "A new disruption is successfully created.",
      });

      handleTimeoutSuccessPrompt(dispatch);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const deleteDisruption = (eventId) => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    try {
      const { data } = await initiateAXIOS.delete(disruptionAPI + eventId, {
        headers: { authorization: `Bearer ${access_token}` },
      });
      dispatch({ type: SET_DELETE_DISRUPTION, payload: data.id });
      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "The disruption is deleted.",
      });

      handleTimeoutSuccessPrompt(dispatch);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const deleteAllDisruption = () => {
  return async (dispatch) => {
    const access_token = sessionStorage.getItem("access_token");
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    try {
      await initiateAXIOS.delete(disruptionAPI, {
        headers: { authorization: `Bearer ${access_token}` },
      });
      dispatch({ type: SET_DELETE_ALL_DISRUPTION, payload: "" });
      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "All disruption is deleted.",
      });
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const getDisruptionAnnouncement = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    const access_token = sessionStorage.getItem("access_token");

    try {
      const { data } = await initiateAXIOS.get(announcementAPI, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      const announcement = await initiateAXIOS.get(
        initiateScheduleAPI + data.announcementId,
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      const disruptionAnnouncement = new Schedule(announcement.data);
      dispatch({
        type: SET_DISRUPTION_ANNOUNCEMENT,
        payload: disruptionAnnouncement,
      });
    } catch (error) {
      dispatch({
        type: SET_DISRUPTION_ANNOUNCEMENT,
        payload: {},
      });
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const activateDisruption = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    const access_token = sessionStorage.getItem("access_token");

    try {
      await initiateAXIOS.post(
        initiateScheduleAPI + payload.id + "/activate",
        {},
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      const disruptionAnnouncement = new Schedule({
        ...payload,
        isActive: true,
      });

      dispatch({
        type: SET_DISRUPTION_ANNOUNCEMENT,
        payload: disruptionAnnouncement,
      });
      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "Disruption is successfully activated.",
      });

      handleTimeoutSuccessPrompt(dispatch);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const deActiveDisruption = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    const access_token = sessionStorage.getItem("access_token");

    try {
      await initiateAXIOS.post(
        initiateScheduleAPI + payload.id + "/deactivate",
        {},
        {
          headers: { authorization: `Bearer ${access_token}` },
        }
      );

      const disruptionAnnouncement = new Schedule({
        ...payload,
        isActive: false,
      });

      dispatch({
        type: SET_DISRUPTION_ANNOUNCEMENT,
        payload: disruptionAnnouncement,
      });
      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "Disruption is successfully de-activated.",
      });

      handleTimeoutSuccessPrompt(dispatch);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};

export const linkDisruption = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING_DISRUPTION, payload: true });
    const access_token = sessionStorage.getItem("access_token");

    try {
      const { data } = await initiateAXIOS.post(announcementAPI, payload, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      const disruptionAnnouncement = new Announcement(data);
      dispatch({
        type: SET_DISRUPTION_ANNOUNCEMENT,
        payload: disruptionAnnouncement,
      });
      dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_DISRUPTION,
        payload: "Disruption is successfully linked.",
      });

      dispatch(getDisruptionAnnouncement());

      handleTimeoutSuccessPrompt(dispatch);
    } catch (error) {
      const errorMessage = handleError(error);
      dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_DISRUPTION, payload: errorMessage });

      handleTimeoutErrorPrompt(dispatch);
    } finally {
      dispatch({ type: SET_LOADING_DISRUPTION, payload: false });
    }
  };
};
